import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import {FormControl} from "../../FormComponents/FormControl";

function Editor({ label, required, error, readOnly = true, defaultValue, onChange }) {
    const containerRef = useRef(null);

    const options = {
        readOnly: readOnly,
        debug: 'none',
        modules: {
            toolbar: true,
        },
        placeholder: readOnly ? '' : 'Start writing...',
        theme: 'snow',
    };
    
    useEffect(() => {
        const container = containerRef.current;
        const editorContainer = container.appendChild(
            container.ownerDocument.createElement('div'),
        );
        const quill = new Quill(editorContainer, options);

        if (defaultValue) {
            const delta = quill.clipboard.convert({html: defaultValue});
            quill.setContents(delta, 'silent')
        }

        quill.on(Quill.events.TEXT_CHANGE, (...args) => {
            const html = quill.getSemanticHTML();
            onChange(html)
        });

        return () => {
            container.innerHTML = '';
        };
    }, []);
    
    return <FormControl controls={{required, error}}>
        {label && <label>{label}</label>}
        <div ref={containerRef}></div>
    </FormControl>
}

export default Editor;